import type { NotificacionPublic } from '@app/shared';

import { api } from '../../../lib/api';

export const notificacionesApi = {
  async list(opts: { soloNoLeidas?: boolean; limit?: number } = {}): Promise<{
    notificaciones: NotificacionPublic[];
  }> {
    const { data } = await api.get<{ notificaciones: NotificacionPublic[] }>('/notificaciones', {
      params: {
        ...(opts.soloNoLeidas !== undefined ? { soloNoLeidas: opts.soloNoLeidas } : {}),
        ...(opts.limit ? { limit: opts.limit } : {}),
      },
    });
    return data;
  },
  async contador(): Promise<{ noLeidas: number }> {
    const { data } = await api.get<{ noLeidas: number }>('/notificaciones/contador');
    return data;
  },
  async marcarLeida(id: string): Promise<{ notificacion: NotificacionPublic }> {
    const { data } = await api.patch<{ notificacion: NotificacionPublic }>(`/notificaciones/${id}/leida`);
    return data;
  },
  async marcarTodasLeidas(): Promise<{ actualizadas: number }> {
    const { data } = await api.post<{ actualizadas: number }>('/notificaciones/marcar-todas-leidas');
    return data;
  },
};
